"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const __1 = require("../");
const product_1 = require("../../sharedTypings/product");
const { NAME, TYPE, } = product_1.ProductField;
const { NULL, OBJECT, STRING, } = __1.JSONSchemaType;
const attributesSchema = {
    type: [OBJECT, NULL],
    properties: {
        effect: { items: __1.stringField },
        flavor: { items: __1.stringField },
        general: { items: __1.stringField },
        ingredient: { items: __1.stringField },
        internal: { items: __1.stringField },
    },
    additionalProperties: false,
};
const productDetailsSchema = {
    type: [OBJECT, NULL],
    properties: {
        cbdMg: __1.numberFieldWithMinZero,
        doseCbdMg: __1.numberFieldWithMinZero,
        doses: __1.numberFieldWithMinZero,
        doseThcMg: __1.numberFieldWithMinZero,
        extractionMethod: __1.stringField,
        grossWeight: __1.numberFieldWithMinZero,
        netWeight: __1.numberFieldWithMinZero,
        strain: __1.stringField,
        thcMg: __1.numberFieldWithMinZero,
        totalWeight: __1.numberFieldWithMinZero,
    },
    additionalProperties: true
};
const descriptionsSchema = {
    type: [OBJECT, NULL],
    properties: {
        main: __1.stringField,
    },
};
const barcodesSchema = {
    items: {
        type: OBJECT,
        maxProperties: 1,
        minProperties: 1,
    }
};
const imagesSchema = {
    items: {
        type: OBJECT,
        properties: {
            url: __1.stringField,
            default: __1.booleanField,
        },
        additionalProperties: false,
    }
};
const ownerTypeSchema = {
    type: STRING,
    enum: lodash_1.default.values(product_1.OwnerType)
};
const statusSchema = {
    type: STRING,
    enum: lodash_1.default.values(product_1.CatalogProductStatus)
};
const typeSchema = {
    type: STRING,
    enum: lodash_1.default.values(product_1.ProductType)
};
const uomSchema = {
    type: STRING,
    enum: lodash_1.default.values(product_1.UOM)
};
const schema = {
    type: OBJECT,
    properties: {
        id: __1.stringField,
        amount: __1.numberFieldWithMinZero,
        attributes: attributesSchema,
        barcodes: barcodesSchema,
        brandName: __1.stringField,
        cannabis: __1.booleanField,
        classification: __1.stringField,
        descriptions: descriptionsSchema,
        details: productDetailsSchema,
        eCommerceName: __1.stringField,
        externalId: __1.stringField,
        images: imagesSchema,
        linkedTo: __1.integerField,
        msrp: __1.numberFieldWithMinZero,
        name: __1.stringField,
        ownerId: __1.stringField,
        ownerType: ownerTypeSchema,
        packageTracked: __1.booleanField,
        price: __1.numberFieldWithMinZero,
        productShortCode: __1.stringField,
        size: __1.stringField,
        sku: __1.stringField,
        status: statusSchema,
        subType: __1.stringField,
        tpc: __1.stringField,
        type: typeSchema,
        uom: uomSchema,
        variantGroupId: __1.integerField,
        visible: __1.booleanField,
        weedMapsProductVariantId: __1.stringField,
        sellTreezId: __1.stringField,
    },
    additionalProperties: true,
    required: [
        NAME,
        TYPE,
    ],
};
exports.default = schema;
//# sourceMappingURL=data:application/json;base64,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